<template>
  <div class="carousel-example">
    <!-- swiper1 -->
    <swiper :options="swiperOptions" class="swiper" ref="swiperTop" >
      <swiper-slide v-for="img in images" :key="img.index">
        <vue-load-image class="horizontal-alignment">
          <img slot="image" class="img-responsive clickable-img" :src="img.url" alt="banner" @click="showImageDetail(img)">
          <img slot="preloader" :src="loader" alt="loader" />
          <img slot="error" :src="placeholder" alt="placeholder" class="img-responsive" />
        </vue-load-image>
      </swiper-slide>
      <div class="swiper-pagination" slot="pagination"></div>
    </swiper>

    <div class="con-upload vx-upload">
      <vx-view-upload v-if="showImage" :src="currentUrl" @on-close-view="closeImage()" />
    </div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
import VxViewUpload from "@upload/VxViewUpload";
import VueLoadImage from 'vue-load-image'
export default {
  name: "ImageCarousel",
  props:{
    images: { type: Array, required: true },
  },
  components: {
    Swiper,
    SwiperSlide,
    VxViewUpload,
    VueLoadImage
  },
  data() {
    return {
      swiperOptions: {
        slidesPerView: 1,
        spaceBetween: 30,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        breakpoints: {
          1024: {
            slidesPerView: 4,
            spaceBetween: 40
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 30
          },
          640: {
            slidesPerView: 2,
            spaceBetween: 20
          },
          500: {
            slidesPerView: 2,
            spaceBetween: 20
          }
        }
      },
      showImage: false,
      currentName: null,
      currentUrl: null,
      loader: require('@assets/images/carousel/loader-green.gif'),
      placeholder: require('@assets/images/pages/placeholder-image.png'),
    }
  },
  methods:{
    async showImageDetail(img){
      this.currentName = img.filename;
      this.currentUrl = img.url;
      this.showImage = true;
    },
    async closeImage(){
      this.showImage = false;
    }
  }
}
</script>
